// extracted by mini-css-extract-plugin
export default {"link":"_2O41Y","tanakLink":"VD9Ea","container":"_3jRIl","hyphen":"_1SQFP","lastItemGroup":"_3ubOb","selected":"_1tDKo"};